import { Container, Typography, Paper, Box } from '@mui/material';

export default function PrivacyPolicy() {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Privacy Policy
        </Typography>

        <Box sx={{ mt: 4 }}>
          <Typography variant="body1" paragraph>
            Privacy statement describes and explains how we may collect and use information
            pertaining yourself through our website. Should you have any questions on our privacy
            policies, please email to us. We understand and respect the importance of your privacy.
            The only way we will get any kind of personal information is if you give it to us when
            we specifically ask for it. We ask you for personal information in a variety of
            circumstances such as:
          </Typography>

          <Typography variant="body1" paragraph>
            1. When you make a reservation or purchase something from our website or through our
            customer service team - by email, letter, or on the phone;
          </Typography>

          <Typography variant="body1" paragraph>
            2. When you register with us for promotions;
          </Typography>

          <Typography variant="body1" paragraph>
            3. When you take part in surveys or provide us with feedback.
          </Typography>

          <Typography variant="body1" paragraph>
            All data we collect about you will be held under Indian law. When you provide
            information through the site you will be providing it to us as a whole, and should be
            aware that it may be accessed from countries whose laws provide various levels of
            protection for personal data, not always equivalent to the level of protection that may
            be provided in your own country. We use your Internet Protocol [IP] address to help
            diagnose problems with our server and/or to administer our Web site. We will not pass on
            any information about you to any third parties. We will restrict access to any
            Confidential Information provided by you to our employees, consultants, representatives,
            advisors and agents who need to know such information for the purposes of approving,
            evaluating or otherwise participating in the process of providing services and ensure
            that such employees, consultants, representatives, advisors and agents are fully aware
            of and agree to be bound by the terms of this statement in writing, prior to disclosure
            of such information to them. Anyone who is on either our mailing or e-mailing lists may
            elect at any time not to receive any future promotional information from us, or to have
            their details suppressed from our mailing lists.
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            Security
          </Typography>
          <Typography variant="body1" paragraph>
            This website has security measures in place to protect the loss, misuse, and/or
            alteration of information under our control. The data resides behind a firewall, with
            access restricted to our authorized personnel. Should you wish to address any questions
            pertaining to the security features of the website, please email to us.
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
}
